@if (isImage(file)) {
  <button type="button" [class]="showThumbnail ? 'attachment-image btn p-0 d-flex align-items-center justify-content-center' : 'btn file-preview-action'"
          [class.primary-btn]="!showThumbnail && primaryButton"
          [disabled]="showThumbnail && !thumbnailUrl" [attr.aria-busy]="thumbnailLoading ? 'true' : null" title="Преглед"
          (click)="openPreview($event)" [attr.aria-label]="'Отвори ја сликата ' + (file.fileName || file.name)">
    @if (!showThumbnail) {
      <fa-icon [icon]="previewIcon" aria-hidden="true" />
      <span>Преглед</span>
    }
    @else {
      @if (thumbnailUrl) { <img [src]="thumbnailUrl" [alt]="file.fileName || file.name || ''" [class.is-loaded]="!thumbnailLoading && !imageError" (load)="thumbnailLoading = false" (error)="onThumbnailError()" /> }
      @if (thumbnailLoading) { <span class="image-skeleton" aria-hidden="true"></span> }
      @if (imageError) { <span class="small text-muted p-3">Недостапна слика</span> }
    }
  </button>
  @if (showThumbnail && imageError) {
    <button type="button" class="btn btn-sm primary-color" (click)="$event.stopPropagation(); loadThumbnail()">Обиди се повторно</button>
  }
  <dialog #imageDialog class="border-0 rounded-4 p-3" (click)="closeOnBackdrop($event)">
    <div class="d-flex align-items-center justify-content-between gap-3 mb-2">
      <span class="text-break">{{file.fileName || file.name}}</span>
      <button type="button" class="btn-close flex-shrink-0" aria-label="Затвори слика" (click)="previewDialog.nativeElement.close()"></button>
    </div>
    @if (fullImageUrl) { <img class="attachment-enlarged" [src]="fullImageUrl" [alt]="file.fileName || file.name || ''" /> }
    @else if (fullImageError) { <p role="alert">Сликата не е достапна.</p><button class="btn btn-sm" (click)="openPreview($event)">Обиди се повторно</button> }
    @else { <p role="status">Вчитување слика…</p> }
  </dialog>
}
